<template>
    <v-footer app :padless="padless" class="pa-0 fixed-bottom">
        <v-card flat tile width="100%" class="blue-grey darken-3 text-center py-0">
            <v-card-text class="white--text text-caption py-1">
                <div class="d-flex" flat tile>
                    <div class="pa-1 mr-auto" outlined tile><strong>Lo que te gusta no tiene porque costar
                            tanto.</strong></div>
                    <div class="pa-1" outlined tile> <strong> {{ new Date().getFullYear() }} Copyright ©
                            SuperExito.</strong> </div>
                </div>
            </v-card-text>
        </v-card>
    </v-footer>
</template>
<script>
export default {
    data: () => ({
        icons: [
            'mdi-home',
            'mdi-email',
            'mdi-calendar',
            'mdi-delete',
        ],
        items: [
            'default',
            'absolute',
            'fixed',
        ],
        padless: true,
    }),
    computed: {

    },
}
</script>
<style>
/* .fixed-bottom {
    position: fixed;
        bottom: 0;
    width: 100%;
} */
</style>








